import { render } from "./HeaderService.vue?vue&type=template&id=785b41a2&scoped=true"
import script from "./HeaderService.vue?vue&type=script&lang=js"
export * from "./HeaderService.vue?vue&type=script&lang=js"

import "./HeaderService.vue?vue&type=style&index=0&id=785b41a2&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-785b41a2"]])

export default __exports__